import { rest } from "src/common/rest";
import { ZUid } from "src/types/zUid";
import { urlBom2a } from "../../apiBom2a";
import {
  zBom2aColorColumn,
  ZBom2aColorColumn,
  zBom2aColorsResponse,
  ZBom2aColorsResponse,
  zBom2aMaterialDescResponse,
  zBom2aPosition,
  ZBom2aPosition,
  zBom2aPositionRow,
  ZBom2aPositionRow,
  ZValue,
} from "./Bom2aPositionsTypes";

export const loadBom2aPositions = async (
  bomId: ZUid,
): Promise<ZBom2aPosition[]> => {
  const response = await rest.get(urlBom2a("/bom-position/get-all-by-bom-id"), {
    params: { bomId },
  });
  return zBom2aPosition.array().parse(response.data);
};

export const createBom2aEmptyPosition = async (
  bomId: ZUid,
  materialTypeId: ZUid,
): Promise<ZBom2aPositionRow[]> => {
  const response = await rest.post(
    urlBom2a("/bom-position/create-empty-bom-position"),
    undefined,
    {
      params: { bomId, materialTypeId },
    },
  );
  return zBom2aPositionRow.array().parse(response.data);
};

export type Bom2aFieldSvRec = {
  id: string;
  value: string | null;
};

export const saveBom2aFields = async (data: {
  id: string; // row id
  fields: Bom2aFieldSvRec[];
}) => {
  await rest.put(urlBom2a("/bom-position/edit-fields"), data);
};

export const loadDynamicColorColumns = async (
  bomId: ZUid,
): Promise<ZBom2aColorColumn[]> => {
  const response = await rest.get(
    urlBom2a("/color-model/get-dynamic-color-columns"),
    { params: { bomId } },
  );
  return zBom2aColorColumn.array().parse(response.data);
};

type ParamsLoadBom2aColors = {
  page: number;
  size: number;
  query?: string;
};

/**
 * Получение списка доступных цветов
 */
export const loadBom2aColors = async (
  params: ParamsLoadBom2aColors,
): Promise<ZBom2aColorsResponse> => {
  const response = await rest.get(urlBom2a("/color/get-paginated"), { params });
  return zBom2aColorsResponse.parse(response.data);
};

export type ParamsCreateBom2aColorModel = {
  params: {
    bomPositionId: ZUid;
    colorModelId: ZUid;
    colorId?: ZUid;
  };
  body: {
    colorManual: ZValue;
    colorReference: ZValue;
    comment: ZValue;
  };
};

export const createBom2aColorModel = async ({
  params,
  body,
}: ParamsCreateBom2aColorModel) => {
  await rest.post(urlBom2a("/bom-position-color-model/create"), body, {
    params,
  });
};

export const assignBom2aColor = async (
  bomPositionColorModelId: ZUid,
  colorId: ZUid | undefined,
) => {
  await rest.post(
    urlBom2a("/bom-position-color-model/assign-color"),
    undefined,
    {
      params: {
        bomPositionColorModelId,
        colorId,
      },
    },
  );
};

export const deleteBom2aPositions = async (ids: string[]) => {
  await rest.delete(urlBom2a("/bom-position/delete-by-id"), { data: ids });
};

export const loadBom2aMaterials = async (params: {
  materialTypeId: ZUid;
  page: number;
  size: number;
  query?: string;
}) => {
  const resp = await rest.get(
    urlBom2a("/material/get-paginated-by-material-type-id"),
    { params },
  );
  return zBom2aMaterialDescResponse.parse(resp.data);
};

export const assignBom2aDesc = async (params: {
  bomPositionId: ZUid;
  descriptionId: ZUid;
}) => {
  await rest.post(urlBom2a("/bom-position/assign-description"), undefined, {
    params,
  });
};

export const createBom2aPositions = async (params: {
  bomId: ZUid;
  descriptionIds: ZUid[];
}) => {
  await rest.post(urlBom2a("/bom-position/create-bom-position"), undefined, {
    params,
    paramsSerializer: {
      indexes: null,
    },
  });
};
